var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOutMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout_FILL0_wght200_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.8002 21C5.3502 21 4.97086 20.846 4.6622 20.538C4.3542 20.2293 4.2002 19.8417 4.2002 19.375V5.625C4.2002 5.15833 4.3542 4.771 4.6622 4.463C4.97086 4.15433 5.3502 4 5.8002 4H12.2252V5H5.8002C5.6502 5 5.51286 5.06267 5.3882 5.188C5.26286 5.31267 5.2002 5.45833 5.2002 5.625V19.375C5.2002 19.5417 5.26286 19.6873 5.3882 19.812C5.51286 19.9373 5.6502 20 5.8002 20H12.2252V21H5.8002ZM16.2752 16.05L15.5752 15.325L17.8752 13H9.2252V12H17.8752L15.5752 9.675L16.2752 8.95L19.8002 12.5L16.2752 16.05Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutMenuIcon);
export default __webpack_public_path__ + "static/media/sign-out-menu-icon.551e7e81a5a90a5679e42bb659cd7939.svg";
export { ForwardRef as ReactComponent };